import React from "react"
import { useLocation } from "react-router"
import { useSelector } from "react-redux"
import { useGlobalFilter, useSortBy, useTable } from "react-table"
import "./table.scss"
import { GlobalFilter } from "./GlobalFilter"
import { MocUserRole } from "core/services/models/Enums"

function Table({
  data,
  columns,
  globalFilterRequired,
  onRowClick,
  onColClick,
  enablePagination,
  pageSizeVal,
  totalPages,
  currPage,
  setCurrPage,
  setPageSizeVal,
  searchText,
  setSearchText
}: any) {

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy
  )

  const { globalFilter } = state
  const userRole = useSelector((state: any) => state?.user?.role)
  const location = useLocation()

  return (
    <div className="table-container">
      {
        globalFilterRequired == true ? (
          (
            userRole !== MocUserRole.MRD && location?.pathname === "/patientList"
            ||
            location?.pathname === "/managePatients"
            ||
            location?.pathname === "/transferPatients"
            ||
            location?.pathname === "/mrd"
          ) ?
            <GlobalFilter filter={searchText} setFilter={setSearchText} />
            :
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        ) : null
      }

      <table {...getTableProps()}>
        <thead className="table-head">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row: any) => {
            prepareRow(row)
            return (
              <tr
                className="table-body-row"
                {...row.getRowProps()}
                onClick={(e) => {
                  onRowClick(row?.original?.id)
                }}
                row={row}
              >
                {row.cells.map((cell: any) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      onClick={(e) => {
                        if (onColClick)
                          onColClick(cell?.column?.id, row?.original?.id, row?.original?.patientId, row?.original)
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          {footerGroups.map((footerGroup) => (
            <tr {...footerGroup.getFooterGroupProps()}>
              {footerGroup.headers.map((column: any) => (
                <td {...column.getFooterProps()}>{column.render("Footer")}</td>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>
      {/* Pagination controls */}
      {enablePagination && (
        <div className="pagination-footer">
          <button
            className="pagination-button"
            onClick={() => {
              setCurrPage(0);
            }}
            disabled={currPage === 0}
          >
            {"First"}
          </button>
          <button
            className="pagination-button"
            onClick={() => {
              setCurrPage(currPage - 1);
            }}
            disabled={currPage === 0}
          >
            {"Previous"}
          </button>
          <span className="pagination-text">
            Page{" "}
            <strong>
              {totalPages === 0 ? 0 : currPage + 1} of {totalPages}
            </strong>
          </span>
          <button
            className="pagination-button"
            onClick={() => {
              setCurrPage(currPage + 1);
            }}
            disabled={currPage === totalPages - 1}
          >
            {"Next"}
          </button>
          <button
            className="pagination-button"
            onClick={() => {
              setCurrPage(totalPages - 1);
            }}
            disabled={currPage === totalPages - 1}
          >
            {"Last"}
          </button>
          <select
            className="pagination-select"
            value={pageSizeVal}
            onChange={(e) => {
              setPageSizeVal(Number(e.target.value));
              setCurrPage(0);
            }}
          >
            {[5, 10, 15, 25, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
      )}
    </div >
  )
}

export default Table
